import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cardData",
  "use": "icon-cardData-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cardData\"><defs><style type=\"text/css\"></style></defs><path d=\"M1024 210.744889V784.782222C1024 854.072889 965.034667 910.222222 892.330667 910.222222H131.697778C58.965333 910.222222 0 854.072889 0 784.810667V210.773333C0 141.482667 58.965333 85.333333 131.669333 85.333333H892.302222C965.034667 85.333333 1024 141.482667 1024 210.744889z m-640.739556 426.382222H184.32c-24.291556 0-43.889778 18.659556-43.889778 41.813333 0 23.096889 19.626667 41.784889 43.889778 41.784889h198.940444c24.291556 0 43.889778-18.688 43.889778-41.813333s-19.598222-41.813333-43.889778-41.813333zM128 312.888889a42.666667 42.666667 0 0 0 0 85.333333h768a42.666667 42.666667 0 0 0 0-85.333333h-768z\" p-id=\"12153\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cardData.svg
// module id = oNfL
// module chunks = 111